import { useQuery } from "react-query";
import { UserApi } from "../api/users.api";
import { CerberusResponse } from "../common/common.typings";

export const useGetUserProfile = (email: string, enabled: boolean) =>
  useQuery<CerberusResponse>(["userProfile"], () => UserApi.getUser(email).then((res) => res), {
    enabled: enabled,
    refetchOnWindowFocus: false,
  });